import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { VehicleComponent } from '../../../components/vehicle/vehicle.component';
import { AuthService } from '../../../services/auth/auth.service';

@Component({
  selector: 'app-vehicles-create',
  standalone: true,
  imports: [CommonModule, FormsModule, VehicleComponent],
  templateUrl: './vehicles-create.component.html',
  styleUrl: './vehicles-create.component.scss'
})
export class VehiclesCreateComponent {
  applicantId: string = '';
  redirectUri: string = '';

  constructor(
    private readonly router: Router,
    private readonly activeRoute: ActivatedRoute,
    private readonly authService: AuthService
  ) {
    this.applicantId = this.authService.getCurrentUser().documentNumber;
    this.redirectUri = this.activeRoute.snapshot.paramMap.get('redirect') || '';
  }

  goToNewException(plate: string) {
    if (this.redirectUri) {
      this.router.navigate([this.redirectUri]);
    } else {
      this.router.navigate(['exceptions', plate, 'new']);
    }
  }

  goBack() {
    if (this.redirectUri) {
      this.router.navigate([this.redirectUri]);
    } else {
      this.router.navigate(['/vehicles']);
    }
  }
}
